// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"122":"2b99323b","495":"b5cd0261","528":"e2d31dde","627":"42319390","644":"04713d2b","795":"c596603e","952":"18fa716f"}[chunkId] + ".css";
};